import { useContext } from 'react';
import CollapsedPortfolioItemsContext from '../CollapsedPortfolioItemsContext';
import StyledCollapseButton from './StyledCollapseButton';
import { FormattedMessage } from 'react-intl';

const CollapseAllButton = () => {
  const { canCollapseAnyPortfolioItem, collapseAllPortfolioItems } = useContext(
    CollapsedPortfolioItemsContext,
  );

  if (!canCollapseAnyPortfolioItem) {
    return null;
  }

  return (
    <StyledCollapseButton
      variant="outlined"
      color="secondary"
      onClick={collapseAllPortfolioItems}
    >
      <FormattedMessage id="portfolio.collapse_all_button" />
    </StyledCollapseButton>
  );
};

export default CollapseAllButton;
